<template>
  <div class="container py-8">
    <div class="flex flex-wrap">
      <div class="text-xl w-full md:w-1/3">
        <h2 class="text-4xl font-semibold tracking-wide">
          {{ $t('contact') }}
        </h2>
        <p class="text-2xl">Folic Architects doo</p>
        <p>Ilije Garašanina 20</p>
        <br />
        <div class="flex items-center">
          <v-icon name="phone"></v-icon
          ><a class="block" href="tel:+381642420733">+381642420733</a>
        </div>
        <div class="flex items-center">
          <v-icon name="mail"></v-icon
          ><a class="" href="mailto:office@folicarchitects.rs"
            >office@folicarchitects.rs</a
          >
        </div>
        <div class="flex items-center">
          <v-icon name="instagram"></v-icon
          ><a class="" href="https://www.instagram.com/folic_arch/"
            >@folic_arch</a
          >
        </div>
      </div>
      <client-only>
        <div class="w-full md:w-2/3 mt-4 md:mt-0">
          <GmapMap
            :center="{ lat: 44.811441, lng: 20.471692 }"
            :zoom="16"
            :options="mapStyle"
            map-type-id="roadmap"
            style="width: 100%; height: 400px"
          >
            <GmapMarker
              key="office"
              :position="{ lat: 44.811441, lng: 20.471692 }"
            />
            <GmapMarker
              key="parking-1"
              :icon="{
                url: '/img/parking.png',
                scaledSize: { width: 24, height: 24 }
              }"
              :position="{ lat: 44.8114, lng: 20.472264 }"
            />
            <!-- <GmapMarker
              key="parking-2"
              :icon="{
                url: '/img/parking.png',
                scaledSize: { width: 24, height: 24 }
              }"
              :position="{ lat: 44.803007, lng: 20.46575 }"
            />
            <GmapMarker
              key="parking-3"
              :icon="{
                url: '/img/parking.png',
                scaledSize: { width: 24, height: 24 }
              }"
              :position="{ lat: 44.80564, lng: 20.478883 }"
            /> -->
          </GmapMap>
        </div>
      </client-only>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mapStyle: {
        styles: [
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e9e9e9'
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 29
              },
              {
                weight: 0.2
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 18
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 16
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              },
              {
                lightness: 21
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dedede'
              },
              {
                lightness: 21
              }
            ]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on'
              },
              {
                color: '#ffffff'
              },
              {
                lightness: 16
              }
            ]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                saturation: 36
              },
              {
                color: '#333333'
              },
              {
                lightness: 40
              }
            ]
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f2f2f2'
              },
              {
                lightness: 19
              }
            ]
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#fefefe'
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#fefefe'
              },
              {
                lightness: 17
              },
              {
                weight: 1.2
              }
            ]
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.vue-map {
  width: 100%;
  height: 100%;
}
</style>
